(function () {
  'use strict';

  var panelSelector = '[data-ee-infusion-accessories]';

  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function showToast(message) {
    var old = document.querySelector('.ee-infusion-accessories-toast');
    if (old) old.remove();
    var toast = document.createElement('div');
    toast.className = 'ee-infusion-accessories-toast';
    toast.innerHTML = message;
    document.body.appendChild(toast);
    setTimeout(function () {
      if (toast.parentNode) toast.remove();
    }, 7000);
  }

  function initPanel(panel) {
    if (!panel || panel.dataset.eeAccessoryInitialized === 'true') return;
    panel.dataset.eeAccessoryInitialized = 'true';

    var form = panel.closest('form[data-product-form]');
    if (!form) return;

    var search = panel.querySelector('[data-ee-accessory-search]');
    var filter = panel.querySelector('[data-ee-accessory-filter]');
    var checkboxes = Array.prototype.slice.call(panel.querySelectorAll('[data-ee-accessory-checkbox]'));
    var items = Array.prototype.slice.call(panel.querySelectorAll('[data-ee-accessory-item]'));
    var countBadge = panel.querySelector('[data-ee-accessory-count]');
    var totalEl = panel.querySelector('[data-ee-accessory-total]');
    var summaryEl = panel.querySelector('[data-ee-accessory-selection-summary]');
    var clearBtn = panel.querySelector('[data-ee-accessory-clear]');
    var noResults = panel.querySelector('[data-ee-accessory-no-results]');
    var message = panel.querySelector('[data-ee-accessory-message]');

    function selected() {
      return checkboxes.filter(function (cb) { return cb.checked && !cb.disabled; });
    }

    function updateSelection() {
      var chosen = selected();
      var total = chosen.reduce(function (sum, cb) {
        return sum + (Number(cb.dataset.eeAccessoryPrice) || 0);
      }, 0);

      if (countBadge) {
        countBadge.hidden = chosen.length === 0;
        countBadge.textContent = chosen.length + (chosen.length === 1 ? ' selected' : ' selected');
      }
      if (totalEl) {
        totalEl.hidden = chosen.length === 0;
        totalEl.textContent = chosen.length ? 'Accessories: ' + money(total) : '';
      }
      if (summaryEl) {
        summaryEl.textContent = chosen.length
          ? chosen.length + (chosen.length === 1 ? ' accessory selected' : ' accessories selected') + ' · ' + money(total)
          : 'No accessories selected';
      }
      if (clearBtn) clearBtn.hidden = chosen.length === 0;
    }

    function updateFilter() {
      var query = search ? search.value.trim().toLowerCase() : '';
      var type = filter ? filter.value : 'all';
      var visible = 0;

      items.forEach(function (item) {
        var title = item.dataset.eeAccessoryTitle || '';
        var itemType = item.dataset.eeAccessoryType || '';
        var matchesQuery = !query || title.indexOf(query) !== -1;
        var matchesType = type === 'all' || itemType === type;
        var show = matchesQuery && matchesType;
        item.classList.toggle('is-hidden', !show);
        if (show) visible += 1;
      });

      if (noResults) noResults.hidden = visible !== 0;
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', updateSelection);
    });

    if (search) search.addEventListener('input', updateFilter);
    if (filter) filter.addEventListener('change', updateFilter);
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        checkboxes.forEach(function (cb) { cb.checked = false; });
        updateSelection();
      });
    }

    form.addEventListener('submit', function (event) {
      var chosen = selected();
      if (!chosen.length) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var variantFields = Array.prototype.slice.call(form.querySelectorAll('[name="id"]'));
      var variantField = variantFields.find(function (field) {
        return !field.disabled && field.value && field.value !== 'not-selected';
      });
      var quantityField = form.querySelector('[name="quantity"]');
      var button = form.querySelector('[data-product-atc]');

      if (!variantField) {
        if (message) {
          message.hidden = false;
          message.classList.add('is-error');
          message.textContent = 'Please choose a pump option before adding accessories.';
        }
        return;
      }

      var mainQuantity = quantityField ? Math.max(1, parseInt(quantityField.value, 10) || 1) : 1;
      var itemsToAdd = [{ id: Number(variantField.value), quantity: mainQuantity }];

      chosen.forEach(function (cb) {
        itemsToAdd.push({ id: Number(cb.value), quantity: 1 });
      });

      if (button) {
        button.disabled = true;
        button.classList.add('processing');
      }
      if (message) {
        message.hidden = false;
        message.classList.remove('is-error');
        message.textContent = 'Adding pump and selected accessories…';
      }

      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: itemsToAdd })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || data.message || 'Unable to add the selected items.');
            });
          }
          return response.json();
        })
        .then(function () {
          return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));

          if (message) {
            message.hidden = false;
            message.classList.remove('is-error');
            message.innerHTML = 'Added the pump and ' + chosen.length + (chosen.length === 1 ? ' accessory' : ' accessories') + ' to your cart.';
          }

          chosen.forEach(function (cb) { cb.checked = false; });
          updateSelection();
          panel.open = false;

          showToast('Pump and accessories added to cart. <a href="' + root + 'cart">View cart</a>');
        })
        .catch(function (error) {
          if (message) {
            message.hidden = false;
            message.classList.add('is-error');
            message.textContent = error.message || 'Unable to add the selected items. Please try again.';
          }
        })
        .finally(function () {
          if (button) {
            button.disabled = false;
            button.classList.remove('processing');
          }
        });
    }, true);

    updateSelection();
    updateFilter();
  }

  function initAll(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll(panelSelector), initPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
        if (!node || node.nodeType !== 1) return;
        if (node.matches && node.matches(panelSelector)) initPanel(node);
        if (node.querySelectorAll) initAll(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
